export default __webpack_public_path__ + "static/media/CarlosMonjaraz__ponentes.69534ce3.png";